import { useLocation } from 'react-router-dom';

export default function useGetCurrentURL() {
    const location = useLocation();
    let { pathname, search, hash } = location;
    return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}